export const px = (token: string | number) => token + 'px';